// @flow

/* Libs */
import React, { useState, useEffect } from 'react';

/* Stores */
import useUserStore from 'Stores/User';

/* Components */
import Button from 'Components/Button';

/* Style */
import './style.scss';

const Login = () => {
	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');
	const [displaySubmit, setDisplaySubmit] = useState(false);
	const [errors, setErrors] = useState(null);
	const login = useUserStore(store => store.login);
	const emailId = 'email';
	const passwordId = 'password';

	useEffect(() => {
		setErrors(null);

		if (Util.isValidEmail(email) && Util.isValidPassword(password)) {
			setDisplaySubmit(true);
		}
	}, [email, password]);

	const handleSubmit = async (e) => {
		e.preventDefault();
		const params = {
			identifier: email,
			password
		};

		const response = await login(params);

		if (response.error) {
			const { message } = response.error.message;

			setErrors(message);
		}
		return false;
	};

	return (
		<div className="login-page layout-component">
			<div className="wrapper login-wrapper">
				<form onSubmit={handleSubmit} className={errors && 'form-error'}>
					<div className="input-wrapper">
						<span>Email</span>
						<input
							id={emailId}
							type="text"
							onChange={(e) => setEmail(e.target.value)}
							placeholder="Entrer email"
							value={email}
						/>
					</div>
					<div className="input-wrapper">
						<span>Mot de passe</span>
						<input
							id={passwordId}
							type="password"
							onChange={(e) => setPassword(e.target.value)}
							placeholder="Entrer mot de passe"
							value={password}
						/>
					</div>
					<Button isSubmit text="Se connecter" disabled={!displaySubmit} />
					{ errors && <p className="error">{errors}</p> }
				</form>
			</div>
		</div>
	);
};

export default Login;
